
import {
  Component, Prop, Watch, Mixins 
} from 'vue-property-decorator';

import BoxWithArrow from '@/components/BoxContainer/BoxWithArrow/index.vue';
import Permission from '@/mixins/permission';
import { LIST_PERMISSION } from '@/constant/ListPermission';

@Component({
  components: {
    BoxWithArrow
  }
})
export default class SubjectBox extends Mixins(Permission) {
  @Prop() index!: number;
  @Prop() showIndex!: boolean;
  @Prop({ default: true }) showArrow!: boolean;
  @Prop() title!: string;
  @Prop() degreeID!: number;
  private openSubject = this.showIndex;

  setOpenSubject() {
    this.openSubject = this.showArrow ? !this.openSubject : false;
  }

  @Watch('$route.params.path')
  setClosed() {
    this.openSubject = false;
  }

  get isVisible() {
    if (!this.title || typeof this.title !== 'string') return true;

    // Aplica o filtro de anos no Fundamental (1, 4) e SAEB (5)
    const shouldFilterByGrade = this.degreeID === 1 || this.degreeID === 4 || this.degreeID === 5;

    if (!shouldFilterByGrade) {
      return true;
    }

    // Se o título não tiver a palavra 'ano', não bloqueamos (ex: "Conteúdos Extras")
    if (!this.title.toLowerCase().includes('ano')) {
      return true;
    }

    // Extrai todos os números puros do título (resolve problema de 'º' x '°' x 'o')
    const matches = [...this.title.matchAll(/(\d+)/g)];

    if (matches.length === 0) {
      return true;
    }

    const grades = matches.map((match) => parseInt(match[0], 10));

    const hasFull = this.can(LIST_PERMISSION.BOOKS_DEGREE_ELEMENTARY_SCHOOL_II);
    const hasEarly = this.can(LIST_PERMISSION.DEGREE_1_EARLY_YEARS);
    const hasFinal = this.can(LIST_PERMISSION.DEGREE_1_FINAL_YEARS);

    if (hasFull) {
      return true;
    }

    // Se possui a permissão dos Iniciais, checa se ao menos uma das séries listadas está entre 1 e 5
    if (hasEarly && grades.some((grade) => grade >= 1 && grade <= 5)) {
      return true;
    }

    // Se possui a permissão dos Finais, checa se ao menos uma das séries listadas está entre 6 e 9
    if (hasFinal && grades.some((grade) => grade >= 6 && grade <= 9)) {
      return true;
    }

    return false;
  }
}
